module.exports = __webpack_public_path__ + "img/bth_bed_right_nor.479de0a1.png";